<ion-header class="ion-no-border">
    
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>Change PIN</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="update()">
				<fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row>
                        <ion-col>
                            <ion-input type="password" inputmode="numeric" maxlength="20" label="Current PIN" labelPlacement="stacked" fill="outline" [(ngModel)]="current_pin" data-1p-ignore="true" autocomplete="off" [autocorrect]="false" autocapitalize="off" spellcheck="false"></ion-input>
                        </ion-col>                 
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-input type="password" inputmode="numeric" maxlength="20" label="New PIN" labelPlacement="stacked" fill="outline" [(ngModel)]="new_pin" data-1p-ignore="true" autocomplete="off" [autocorrect]="false" autocapitalize="off" spellcheck="false"></ion-input>
                        </ion-col>       
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>
